// extracted by mini-css-extract-plugin
export default {"button":"button_button__y45Ks","contained":"button_contained__nurwM","textVariant":"button_textVariant__8tCI3"};